import { useState } from 'react';
import { withTranslation } from 'react-i18next';
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
import { Switch, Route, useRouteMatch, useHistory, useLocation } from 'react-router-dom';

import BotHeader from 'components/bots/BotHeader';
import JobList from 'components/bots/jobs/JobList';

import AgendaTab from './AgendaTab';
import ConfigTab from './ConfigTab';
import ReportTab from './ReportTab';
import AddJobPage from './AddJobPage';
import JobDetailsPage from './JobDetailsPage';
import JobWarningsPage from './JobWarningsPage';
import AddReportPage from './AddReportPage';
import AgendaEventDetailsPage from './AgendaEventDetailsPage';

const BotPage = ({ t }) => {
  const history = useHistory();
  const location = useLocation();
  const { params, url, path } = useRouteMatch();
  const query = new URLSearchParams(location.search);

  const { botId } = params;
  const [current_tab, setTab] = useState(query.get('tab', 'jobs'));

  const tabIndexes = {
    jobs: 0,
    calendar: 1,
    reports: 2,
    config: 3,
  };

  const backUrl = {
    pathname: url,
    search: `?tab=${current_tab}`,
  };

  const handleTabChange = tabIndex => {
    const tab = Object.keys(tabIndexes).find(key => tabIndexes[key] === tabIndex);
    setTab(tab);
    history.push({ search: `?tab=${tab}` });
  };

  return (
    <Tabs defaultIndex={tabIndexes[current_tab]} onSelect={handleTabChange} className="react-tabs">
      <BotHeader botId={botId} />

      <div className="pt-3 pb-5">
        <div className="container">
          <TabList>
            <Tab>{t('bots.tabs.jobs')}</Tab>
            <Tab>{t('bots.tabs.calendar')}</Tab>
            <Tab>{t('bots.tabs.reports')}</Tab>
            <Tab>{t('bots.tabs.config')}</Tab>
          </TabList>
        </div>

        <div className="container">
          <TabPanel>
            <JobList botId={botId} />
          </TabPanel>

          <TabPanel>
            <AgendaTab botId={botId} />
          </TabPanel>

          <TabPanel>
            <ReportTab botId={botId} />
          </TabPanel>

          <TabPanel>
            <ConfigTab botId={botId} />
          </TabPanel>
        </div>
      </div>

      <Switch>
        <Route exact path={`${path}/jobs/add`} children={<AddJobPage backUrl={backUrl} botId={botId} />} />
        <Route exact path={`${path}/jobs/:jobId/details`} children={<JobDetailsPage backUrl={backUrl} botId={botId} />} />
        <Route exact path={`${path}/jobs/:jobId/warnings`} children={<JobWarningsPage backUrl={backUrl} botId={botId} />} />
        <Route exact path={`${path}/reports/add`} children={<AddReportPage backUrl={backUrl} botId={botId} />} />
        <Route exact path={`${path}/agenda/:jobId`} children={<AgendaEventDetailsPage backUrl={backUrl} />} />
      </Switch>
    </Tabs>
  );
};

export default withTranslation()(BotPage);
